const TailOutIcon = ({
  width = 8,
  height = 13,
  fill = "#20cb6449",
  shadowOpacity = 0.13,
}) => {
  return (
    <svg
      viewBox="0 0 8 13"
      width={width}
      height={height}
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity={shadowOpacity}
        d="M5.188,1H0v11.193l6.467-8.625C7.526,2.156,6.958,1,5.188,1z"
      />
      <path
        fill={fill}
        d="M5.188,0H0v11.193l6.467-8.625C7.526,1.156,6.958,0,5.188,0z"
      />
    </svg>
  );
};

export default TailOutIcon;
